import { render, staticRenderFns } from "./DiscussionListCard.vue?vue&type=template&id=936464f4&scoped=true"
import script from "./DiscussionListCard.vue?vue&type=script&lang=js"
export * from "./DiscussionListCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "936464f4",
  null
  
)

export default component.exports